import { toast } from 'react-hot-toast';
import { toLink } from '../utils/stringUtils';
import { chainSummary } from '../scenarios/scenarioSlice';
import { toHtmlTable } from '../utils/objectUtils';
import { copyToClipboard } from '../utils/clipboardUtils';

/**
 *
 * @param {import('./scenarioSlice').Scenario} scenario
 * @param {import('./scenarioSlice').OperationChain} chain
 * @returns {string[]}
 */
export const getUniqueTsps = (scenario, chain) => {
  const tsps = chain.operations.flatMap((op_id) => {
    const operation = scenario.operations.find((op) => op.id === op_id);
    return [
      operation.receipt_point.tsp_name,
      operation.delivery_point.tsp_name,
    ];
  });
  const uniqueTsps = tsps.filter(
    (tsp, index) => tsp && tsps.indexOf(tsp) === index,
  );

  return uniqueTsps;
};

/**
 *
 * @param {{
 *  operation: import('@/types').Operation
 * }} props
 * @returns
 */
export const LinkToRates = ({ operation }) => {
  return (
    <>
      <a
        className={operation.has_commodity_rate ? '' : 'text-danger'}
        href={`/contracts/?edit_contract=${operation.contract_id}`}
        target="_blank"
        rel="noreferrer"
      >
        {operation.has_commodity_rate ? 'Update' : 'Add'} Commodity Rate
      </a>
      <br />
      <a
        className={operation.has_fuel_rate ? '' : 'text-danger'}
        href={`/contracts/?edit_contract=${operation.contract_id}`}
        target="_blank"
        rel="noreferrer"
      >
        {operation.has_fuel_rate ? 'Update' : 'Add'} Fuel Rate
      </a>
    </>
  );
};
